import * as API from '@/services/API';

export default {
  get(id) {
    return API.apiClient.get(`/user-groups/${id}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/user-groups/${query}`);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/user-groups`, data);
    } else {
      return API.apiClient.put(`/user-groups/${id}`, data);
    }
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  search(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/user-groups/search${query}`);
  },
  async delete(id) {
    return API.apiClient.delete(`/user-groups/${id}`);
  }
};
